import { defineStore } from 'pinia'
import { useRequestFactory } from './factories/requestFactory'
import { MonitoringV2Service } from '@/services/monitoring-v2-service'
import { ref } from 'vue'
import type { UserMonitoringResponse } from '@/services/monitoring-v2-service/types'

type ActionFlag = 'fetch' | 'save' | 'deleting'
export const useMonitoringStore = defineStore('monitoring', () => {
  const { loading, errors, requestHandler } = useRequestFactory<ActionFlag>()

  const monitoring = ref<UserMonitoringResponse[]>([])

  const fetchMonitorings = async () => {
    return await requestHandler('fetch', async () => {
      const req = await MonitoringV2Service.fetchUserMonitoring()
      monitoring.value = req.data
      return req.data
    })
  }

  const deleteMonitoring = async (rowId: number) => {
    return await requestHandler('deleting', async () => {
      const req = await MonitoringV2Service.deleteUserMonitoring(rowId)
      monitoring.value = monitoring.value.filter((x) => x.id != rowId)
      return req.data
    })
  }

  const saveMonitoring = async (
    exBuy: string,
    exSell: string,
    asset: string,
    spread: number | null,
    backspread: number | null,
    isSpot: boolean,
  ) => {
    return await requestHandler('save', async () => {
      const req = await MonitoringV2Service.saveUserMonitoring(
        exBuy,
        exSell,
        asset,
        spread,
        backspread,
        isSpot,
      )
      monitoring.value = req.data
      return req.data
    })
  }

  return {
    fetchMonitorings,
    saveMonitoring,
    deleteMonitoring,
    loading,
    errors,
    monitoring,
  }
})
